module.exports = __webpack_public_path__ + "static/_oldsLogo-c98fd5b3ea34d00c1001996af513e414.png";